import { fg } from '@atlassian/jira-feature-gating';

const JiraMwivEmptyStateRedesignGate2RelayProvider = {
	get(): boolean {
		return fg('mwiv_empty_state_redesign_gate_2');
	},
};

export default JiraMwivEmptyStateRedesignGate2RelayProvider;
